<script setup lang="ts">
defineOptions({ inheritAttrs: false })

const { t } = useI18n()
</script>

<template>
  <AppTooltip :text="t('pages.loyaltySupports.webapp.editor.previewOnly.description')">
    <Badge v-bind="$attrs" variant="neutral">{{ t('pages.loyaltySupports.webapp.editor.previewOnly.badge') }}</Badge>
  </AppTooltip>
</template>
